/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Dl_Kind_CliInputs */

const en_fc_dl_kind_cli = /** @type {(inputs: Fc_Dl_Kind_CliInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Command-line tools (zip)`)
};

/**
* | output |
* | --- |
* | "Command-line tools (zip)" |
*
* @param {Fc_Dl_Kind_CliInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_dl_kind_cli = /** @type {((inputs?: Fc_Dl_Kind_CliInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Dl_Kind_CliInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_dl_kind_cli(inputs)
});
export { fc_dl_kind_cli as "fc.dl.kind.cli" }